import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { useFormik } from "formik";
import {
  accountOpeningSteps,
  guardianInitialDetails,
  minorInitialDetails,
  monthNames,
  statesInNigeria,
} from "../../utils/constants";
import Loader from "../Loader";
import CustomInputField from "../CustomInputField/CustomInputField";
import CustomDropdown from "../CustomDropdown";
import SectionLabel from "../SectionLabel";
import FormHelperText from "../FormHelperText";
import {
  extractValuesFromObj,
  handleNumericInput,
  handleNumericPaste,
  isEmptyObj,
  returnInputErrorMessage,
  returnLgaError,
} from "../../utils/helpers";
import { minorDetailsValidationSchema } from "../../utils/validationSchemas";
import apiHooks from "../../customHooks/apis";
import {
  GuardianDetailsPayload,
  MinorDetailsPayload,
} from "../../models/IEnums.model";
import DocUpload from "../DocUpload";
import useAutoUpdateAddress from "../../customHooks/useAutoUpdateAddress";

function UpdateDetailSwiftSavingsDialog(props: any) {
  const dispatch = useDispatch();
  const {
    useGetRelationships,
    useGetReligions,
    useUpdateMinorDetails,
    useUserDetails,
  } = apiHooks;
  const { handleUpdateUserDetails } = useUserDetails();
  const { handleUpdateMinorDetails, updatingMinorDetails, userDetails } =
    useUpdateMinorDetails();
  const {} = useGetRelationships();
  const { religions, getSelectedReligion } = useGetReligions();
  const [otpLoader] = useState(false);
  const [genders] = useState<any[]>([
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
  ]);
  const [lgas, setLgas] = useState([]);
  const goToStep = (step: string) => {
    handleUpdateUserDetails(formik.values);
    dispatch(setAccountOpeningStep(step));
  };

  const formik = useFormik<MinorDetailsPayload>({
    initialValues: {
      ...minorInitialDetails,
      minorEmail: userDetails?.emailAddress || "",
    },
    validationSchema: minorDetailsValidationSchema,
    validateOnBlur: true,
    onSubmit: (values) => {
      handleUpdateMinorDetails({
        ...extractValuesFromObj(guardianInitialDetails, userDetails),
        ...values,
        minorEmail: userDetails?.emailAddress,
      });
    },
  });
  useAutoUpdateAddress<MinorDetailsPayload>({
    formik,
    fieldNames: [
      "minorHouseNumber",
      "minorStreetName",
      "minorNearestBusStop",
      "minorState",
    ],
    name: "minorAddress",
  });
  // const handleBlurAddressChild = (
  //   event: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  // ) => {
  //   const { name } = event.target;
  //   formik.setValues({
  //     ...formik.values,
  //     minorAddress:
  //       `${formik.values?.minorHouseNumber} ${formik.values?.minorStreetName} ${formik.values?.minorNearestBusStop} ${formik.values?.minorState}`.trim(),
  //   });
  //   formik.setFieldTouched(name, true);
  // };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const charCode = event.which || event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = event.target.value;

    const state = statesInNigeria.find((state) => state.name === selected);
    if (state) {
      setLgas(state.lgas);
    } else {
      setLgas([]);
    }
    formik.handleChange(event);
  };

  useEffect(() => {
    formik.setValues({
      ...minorInitialDetails,
      ...extractValuesFromObj(minorInitialDetails, userDetails),
    });
    formik.setFieldValue(
      "minorDob",
      `${userDetails?.minorYear || ""}-${
        monthNames[userDetails?.minorMonth] || ""
      }-${userDetails?.minorDay || ""}`,
    );
  }, [userDetails]);

  return (
    <div>
      {otpLoader && <Loader />}
      <div className=" card-form pl-1 pr-1 ">
        <form
          onSubmit={formik.handleSubmit}
          className="update-details-form-body"
        >
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-4">
              Update Minor Details
            </h4>
            <p className="text-center pl-5 no-wrap">
              Hello{" "}
              <span className="font-weight-bold">
                <b>{userDetails.firstName},</b>{" "}
              </span>
              Welcome to The Alternative Bank
            </p>
            <FormHelperText />
            <div className="row">
              <div className="col mt-4 pt-2 sec">
                <div className="row form-row mb-3">
                  <div className="col-lg-6 sec">
                    <CustomInputField
                      label="Minor Full name"
                      name="minorFullName"
                      value={formik.values.minorFullName}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Enter Minor Full Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      errorMessage={returnInputErrorMessage<
                        typeof formik.initialValues
                      >(formik, "minorFullName")}
                      required
                    />
                  </div>

                  <div className="col-lg-6">
                    <CustomInputField
                      label="NIN (Optional)"
                      placeholder="Enter NIN"
                      name="minorNIN"
                      value={formik.values.minorNIN}
                      type="text"
                      className="form-control bg-white border-dark"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onKeyDown={handleNumericInput}
                      onPaste={handleNumericPaste}
                      maxLength={11}
                      errorMessage={returnInputErrorMessage<MinorDetailsPayload>(
                        formik,
                        "minorNIN",
                      )}
                    />
                  </div>
                </div>

                <div className="row form-row mb-3">
                  <div className="col-lg-6">
                    <CustomInputField
                      label="Minor Email Address"
                      name="minorEmail"
                      value={formik.values.minorEmail}
                      type="email"
                      className="form-control bg-white border-dark"
                      placeholder="Enter Email Address"
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <CustomInputField
                      label="Minor Phone Number"
                      name="minorPhoneNumber"
                      value={formik.values.minorPhoneNumber}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="e.g. 08031234567"
                      onChange={formik.handleChange}
                      onKeyDown={handleNumericInput}
                      onPaste={handleNumericPaste}
                      onBlur={formik.handleBlur}
                      maxLength={11}
                      errorMessage={returnInputErrorMessage<MinorDetailsPayload>(
                        formik,
                        "minorPhoneNumber",
                      )}
                    />
                  </div>
                </div>
                <CustomDropdown
                  required
                  extraClasses="mt-2"
                  label="Religion"
                  name="minorReligion"
                  labelKey="religion"
                  valueKey="id"
                  onClickOption={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={getSelectedReligion(
                    formik.values.minorReligion as number,
                  )}
                  options={religions}
                  formik={formik}
                  errorMessage={returnInputErrorMessage<
                    typeof formik.initialValues
                  >(formik, "minorReligion")}
                />
              </div>
            </div>

            <SectionLabel label="Minor Residential Information" />

            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <CustomInputField
                    label="House number"
                    name="minorHouseNumber"
                    onChange={formik.handleChange}
                    value={formik.values.minorHouseNumber}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    onKeyPress={handleKeyPress}
                    className="form-control bg-white border-dark"
                    placeholder="eg. 12"
                    pattern="[0-9]*"
                    required
                    errorMessage={returnInputErrorMessage<
                      typeof formik.initialValues
                    >(formik, "minorHouseNumber")}
                  />
                </div>
                <div className="col-lg-6">
                  <CustomInputField
                    name="minorStreetName"
                    onChange={formik.handleChange}
                    value={formik.values.minorStreetName}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Bode Thomas"
                    label="Street name"
                    errorMessage={returnInputErrorMessage<
                      typeof formik.initialValues
                    >(formik, "minorStreetName")}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6">
                  <CustomInputField
                    required
                    label="Nearest bus-stop/landmark"
                    name="minorNearestBusStop"
                    onChange={formik.handleChange}
                    value={formik.values.minorNearestBusStop}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Masha round about"
                    errorMessage={
                      returnInputErrorMessage<typeof formik.initialValues>(
                        formik,
                        "minorNearestBusStop",
                      ) as string
                    }
                  />
                </div>
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    required
                    label="State"
                    name="minorState"
                    onClickOption={handleStateChange}
                    value={formik.values.minorState}
                    // onBlur={handleBlurAddressChild}
                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                    placeholder="Select state"
                    labelKey="name"
                    valueKey="name"
                    options={statesInNigeria}
                    formik={formik}
                    errorMessage={
                      returnInputErrorMessage<typeof formik.initialValues>(
                        formik,
                        "minorState",
                      ) as string
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    name="minorLGA"
                    onClickOption={formik.handleChange}
                    value={formik.values.minorLGA}
                    // onBlur={handleBlurAddressChild}
                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                    label="Local Government Area (L.G.A)"
                    placeholder="Select LGA"
                    options={lgas}
                    formik={formik}
                    errorMessage={
                      formik.touched.minorLGA &&
                      formik.errors.minorLGA &&
                      returnLgaError({
                        stateError: formik.errors.minorState,
                        lgaError: formik.errors.minorLGA,
                      })
                    }
                    required
                  />
                </div>

                <div className="col-lg-6 mr-2">
                  <label htmlFor="minorAddress" className="label_text">
                    Enter full address<span className="text-danger">*</span>
                  </label>
                  <input
                    name="minorAddress"
                    onChange={formik.handleChange}
                    value={formik.values.minorAddress}
                    onBlur={formik.handleBlur}
                    className="form-control sec border-dark"
                    type="text"
                    id="minorAddress"
                    placeholder="No 12 Bode Thomas Masha round about Lagos"
                    readOnly
                  />
                  {formik.touched.minorAddress && formik.errors.minorAddress ? (
                    <small className="text-danger">
                      {formik.errors.minorAddress}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>

            <SectionLabel label="Minor Document Information" />
            <small>
              The file format should be JPEG, PNG or PDF (max size: 2mb)
            </small>
            <div className="row form-row mb-3 mt-3 align-items-end">
              <div className="col-lg-6 mr-2">
                <DocUpload
                  name="minorBirthCertificate"
                  getFileUrl={formik.setFieldValue}
                  show
                  label="Minor’s Birth Certificate"
                  bottomText=""
                  required
                />
              </div>
              <div className="col-lg-6 mr-2">
                <DocUpload
                  name="minorPassport"
                  getFileUrl={formik.setFieldValue}
                  show
                  label="Minors Passport Photograph"
                  required
                />
              </div>
            </div>
            <div>
              <div className="d-flex justify-content-end mt-4">
                <button
                  onClick={() => {
                    goToStep(accountOpeningSteps.guardianDetails);
                  }}
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-gold btn-filled-white"
                  type="button"
                >
                  Previous
                </button>
                {updatingMinorDetails ? (
                  <div className="spinner-border text-gold" role="status">
                    <span className="sr-only"></span>
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-filled-red"
                    disabled={isEmptyObj(formik.touched) || !formik.isValid}
                  >
                    Proceed
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateDetailSwiftSavingsDialog;
